import { useState, useEffect } from 'react';
import { appointmentService } from '../../../services/appointmentService';
import { wellbeingService } from '../../../services/wellbeingService';
import { supabase } from '../../../lib/supabase';

export const useDashboardData = () => {
  const [appointments, setAppointments] = useState([]);
  const [wellbeingScore, setWellbeingScore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState({
    totalSessions: 0,
    upcomingSessions: 0,
    averageRating: 0,
    wellnessScore: 0
  });

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    setLoading(true);
    setError('');
    
    try {
      // Check authentication before loading data
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) {
        setLoading(false);
        return;
      }

      const { data: apptData, error: apptError } = await appointmentService?.getUserAppointments();
      if (apptError) throw apptError;
      
      setAppointments(apptData || []);
      
      const { data: wellbeingData, error: wellbeingError } = await wellbeingService?.getLatestScore();
      if (wellbeingError) throw wellbeingError;
      
      setWellbeingScore(wellbeingData);
      
      const upcoming = apptData?.filter(a => a?.status === 'upcoming' || a?.status === 'scheduled')?.length || 0;
      const completed = apptData?.filter(a => a?.status === 'completed')?.length || 0;
      
      setStats({
        totalSessions: completed,
        upcomingSessions: upcoming,
        averageRating: 4.8,
        wellnessScore: wellbeingData?.score || 0
      });
    } catch (err) {
      setError(err?.message || 'Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  return { appointments, wellbeingScore, loading, error, stats, loadDashboardData };
};